import { api } from "../../lib/api";
import { DOC_TYPE_OPTIONS } from "./docTypes";

const LABELS = Object.fromEntries(DOC_TYPE_OPTIONS);

export const filesLabel = (n) => `${n} ${n === 1 ? "archivo" : "archivos"}`;

export const typeRows = (types = {}) => Object.entries(types).sort((a, b) => b[1] - a[1]).map(([k, n]) => [LABELS[k] || k, n, k]);

export const jobMsg = (j) => {
  const moved = j.counts?.movidos || 0;
  if (moved === 0) return "No se encontraron archivos para clasificar";
  return moved === 1 ? "Se clasificó 1 archivo" : `Se clasificaron ${moved} archivos`;
};

const MAX_FAILS = 5;

// polls the background job until it ends; tolerates a few transient network errors
export const pollJob = async (id, onUpdate, cancelled) => {
  let fails = 0;
  for (;;) {
    await new Promise((r) => setTimeout(r, 1500));
    if (cancelled()) return null;
    try {
      const j = (await api.get(`/bandeja/reclassify/${id}`, { timeout: 20000 })).data;
      fails = 0;
      if (j.status !== "en_curso") return j;
      onUpdate(j);
    } catch (err) {
      fails += 1;
      if (fails >= MAX_FAILS) throw err;
    }
  }
};
